import React from 'react';
import InputDateTime from "../../../../components/input/input-datetime.jsx";
import SelectComponent from "../../../../components/select/select-component.jsx";
import {minMenuHeight} from "../../../../components/reports/report-menu/menu.jsx";
import useReportFiltersFetch from "../../../../hooks/use-report-filters-fetch.js";

const Filters = ({ setFilters, filters }) => {
    const { sosRecordsTypePlace, sosRecordsProtectionPrograms } = useReportFiltersFetch({ fetchSosRecordsTypePlace: true, fetchSosRecordsProtectionPrograms: true });

    return (
        <>
            <div className={`mb-2 ${minMenuHeight}`}>
                <form className="space-y-4">

                        <InputDateTime
                            id="dtStart"
                            label="Data/hora de cadastro inicial *"
                            selected={filters.dtStart}
                            onChange={(date) => setFilters(prev => ({...prev, dtStart: date}))}
                            classNameWrapper={"w-full"}
                            dateFormat="LL"
                        />

                        <InputDateTime
                            id="dtEnd"
                            label="Data/hora de cadastro final *"
                            selected={filters.dtEnd}
                            onChange={(date) => setFilters(prev => ({...prev, dtEnd: date}))}
                            classNameWrapper={"w-full"}
                            dateFormat="LL"
                        />

                        <SelectComponent
                            label='Status'
                            isMulti={true}
                            options={[
                                {label: "Ativo", value: 'ACTIVATED'},
                                {label: "Inativo", value: 'INACTIVATED'}
                            ]}
                            value={filters.status}
                            onChange={(value) => setFilters(prev => ({...prev, status: value}))}
                            instanceId="status"
                            classNameWrapper={"w-full"}
                            isClearable={true}
                        />

                        <SelectComponent
                            label='Programas de proteção'
                            isMulti={true}
                            options={sosRecordsProtectionPrograms}
                            value={filters.programs}
                            onChange={(value) => setFilters(prev => ({...prev, programs: value}))}
                            instanceId="programs"
                            classNameWrapper={"w-full"}
                            isClearable={true}
                        />

                        <SelectComponent
                            label='Risco'
                            isMulti={true}
                            options={[
                                {label: "Não informado", value: 'WITHOUT-RISK'},
                                {label: "Baixo", value: 'LOW'},
                                {label: "Médio", value: 'MEDIUM'},
                                {label: "Alto", value: 'HIGH'}
                            ]}
                            value={filters.life_risk}
                            onChange={(value) => setFilters(prev => ({...prev, life_risk: value}))}
                            instanceId="life_risk"
                            classNameWrapper={"w-full"}
                            isClearable={true}
                        />

                        <SelectComponent
                            label='Tipo de local'
                            isMulti={true}
                            wrapValues={true}
                            options={sosRecordsTypePlace}
                            value={filters.typePlace}
                            onChange={(value) => setFilters(prev => ({...prev, typePlace: value}))}
                            instanceId="typePlace"
                            classNameWrapper={"w-full"}
                        />

                        <SelectComponent
                            label='Uso do aplicativo'
                            isMulti={true}
                            options={[
                                {label: "Sim", value: 'TRUE'},
                                {label: "Não", value: 'FALSE'}
                            ]}
                            value={filters.no_app}
                            onChange={(value) => setFilters(prev => ({...prev, no_app: value}))}
                            instanceId="no_app"
                            classNameWrapper={"w-full"}
                            isClearable={true}
                        />

                </form>
            </div>
        </>
    );
};

export default Filters;